import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import { Dropdown } from 'components/dropdown'
import React, { SyntheticEvent } from 'react'
import { Publication } from 'types/publication'
import { IFilter } from 'types/IFilter'

type ClickHandler = (option: string | undefined, event: SyntheticEvent) => void

export interface IFilterHandlers {
  handleAge: ClickHandler
  handleEducation: ClickHandler
  handleGender: ClickHandler
  handlePublication: ClickHandler
}

export interface IFilterOptions {
  availablePublications?: Publication[]
  availableAges?: string[]
  availableGenders?: string[]
  availableEducation?: string[]
}

export function Filter({
  age,
  gender,
  publication,
  education,
  handleAge,
  handleGender,
  handleEducation,
  handlePublication,
  availableAges = [],
  availableGenders = [],
  availableEducation = [],
  availablePublications = []
}: IFilter & IFilterHandlers & IFilterOptions) {
  const createOptions = (list: string[]) =>
    list
      .map(item => ({
        text: item,
        value: item
      }))
      .sort((a, b) => {
        // Always sort "keine Angabe" last
        if (a.value === 'keine Angabe') {
          return 100
        }
        return a.value.localeCompare(b.value, 'de-CH', { numeric: true })
      })

  return (
    <div className={`ui top attached fitted segment filter`}>
      <h4 className='ui infographic header'>Daten filtern nach</h4>

      <div className='ui equal width form'>
        <div className='fields'>
          <div className='field'>
            <label>Alter</label>
            <Dropdown
              options={createOptions(availableAges as string[])}
              changeHandler={handleAge}
              currentValue={age}
            />
          </div>

          <div className='field'>
            <label>Geschlecht</label>
            <Dropdown
              options={createOptions(availableGenders as string[])}
              changeHandler={handleGender}
              currentValue={gender}
            />
          </div>
        </div>

        <div className='fields'>
          <div className='field'>
            <label>Bildung</label>
            <Dropdown
              options={createOptions(availableEducation as string[])}
              changeHandler={handleEducation}
              currentValue={education}
            />
          </div>

          <div className='field'>
            <label>Publikation</label>
            <Dropdown
              options={createOptions(availablePublications as string[])}
              changeHandler={handlePublication}
              currentValue={publication}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
